import UnitModel from '../models/UnitModel';
import BaseStore from './BaseStore';

class UnitStore extends BaseStore {
  constructor(transportLayer) {
    super(UnitModel, transportLayer);
  }
}

export default UnitStore;



// WEBPACK FOOTER //
// ./src/stores/UnitStore.js